import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/hooks/useToast';

export const useGoogleAuth = () => {
  const [isLoading, setIsLoading] = useState(false);

  const signInWithGoogle = async () => {
    setIsLoading(true);

    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: window.location.origin
      },
    });

    if (error) {
      console.error('Error signing in with Google:', error);
      toast({
        title: "Errore Google",
        description: "Impossibile procedere con Google. Riprova.",
        variant: "destructive",
      });
    }

    setIsLoading(false);
    return { error };

  };

  return {
    signInWithGoogle,
    isLoading
  };
}; 